import React from 'react';
import styled from 'styled-components';
import { colors } from '_styles';

const Label = styled.label`
  font-weight: 400 !important;
  font-size: 14px !important;
`;

const Checkbox = styled.input`
  transform:scale(1.5);
  margin-right: 10px;
  accent-color: ${colors.RC_ACTION};
`;

const SingleCheckbox = ({
  onClick, checked, id, name, label, ref
}) => (
  <Label htmlFor={id}>
    <Checkbox
      type="checkbox"
      id={id}
      name={name}
      checked={checked}
      onClick={onClick}
      ref={ref}
    />
    {label}
  </Label>
);

export default SingleCheckbox;
